'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { TypeListItem } from "../TypeListItem/index.mjs";
import styled from "../../styled-components.mjs";
export var PopoverNavigationItemElement = styled(TypeListItem).attrs({
  variant: 'bodySmall',
  condensed: true,
  listStyleReset: true
}).withConfig({
  displayName: "PopoverNavigationItem__PopoverNavigationItemElement",
  componentId: "sc-1w8ibku-0"
})([""]);
export var PopoverNavigationItem = /*#__PURE__*/React.forwardRef(function PopoverNavigationItem(_ref, ref) {
  var as = _ref.as,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(PopoverNavigationItemElement, Object.assign({}, props, {
    ref: ref,
    forwardedAs: as,
    "data-encore-id": ENCORE_DATA_IDS.PopoverNavigationItem
  }));
});